/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const dentalTreatments = sqliteTable('dental_treatments', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  created_encounter_id: text('created_encounter_id'),
  treatment: text('treatment'),
  status: text('status'),
  source: text('source'),
  source_ref: text('source_ref'),
  source_diagnosis_id: text('source_diagnosis_id'),
  source_label: text('source_label'),
  created_by_user_id: text('created_by_user_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
